function sieroty() {
    const contentWrapper = document.querySelector(".js-content-wrapper");
    if (contentWrapper) {
        const paragraphs = contentWrapper.querySelectorAll("p, h1, h2, h3, h4, h5, span, li, a");
        paragraphs.forEach(function (paragraph) {
            let current = paragraph.innerHTML;
            current = current.replace(/  +/g, ' ');
            current = current.replace(/\s([a])\s/g, ' $1&nbsp;');
            current = current.replace(/\s([i])\s/g, ' $1&nbsp;');
            current = current.replace(/\s([o])\s/g, ' $1&nbsp;');
            current = current.replace(/\s([u])\s/g, ' $1&nbsp;');
            current = current.replace(/\s([w])\s/g, ' $1&nbsp;');
            current = current.replace(/\s([z])\s/g, ' $1&nbsp;');

            paragraph.innerHTML = current;
        });
    }
}

function removeDoubleSpace () {
    if (document.querySelector(".content-wrapper")) {
        const elements = document.querySelectorAll(".content-wrapper p, .content-wrapper h1, .content-wrapper h2, .content-wrapper h3, .content-wrapper h4, .content-wrapper h5, .content-wrapper h6, .content-wrapper span, .content-wrapper a, .content-wrapper li");
        elements.forEach(function (element) {
            let currentContent = element.innerHTML;
            currentContent = currentContent.replace(/ {2,}/g, ' ');
            element.innerHTML = currentContent;
        });
    }
}

function changeHeaderBorderBottom() {
    if (document.querySelectorAll(".content-wrapper h2")) {
        const headers = document.querySelectorAll(".content-wrapper h2");

        headers.forEach((header, index) => {
            if (header.className.includes("section")) { // Sprawdź, czy klasa zawiera "section"
                const style = window.getComputedStyle(header);

                if (style.borderBottomStyle !== "none" && style.borderBottomWidth !== "0px") {
                    const borderBottomWidth = style.borderBottomWidth;
                    const borderBottomColor = style.borderBottomColor;

                    header.style.borderBottom = "none";
                    header.style.position = "relative"; // Aby ::after działało poprawnie

                    const uniqueClass = `h2-after-${index}`;
                    header.classList.add(uniqueClass);

                    const sheet = document.styleSheets[0];
                    sheet.insertRule(`
                .${uniqueClass}::after {
                    content: "";
                    position: absolute;
                    bottom: -5px;
                    left: 0;
                    width: 100%;
                    height: ${borderBottomWidth};
                    background-color: ${borderBottomColor};
                    border-radius: ${parseInt(borderBottomWidth) / 2}px;
                }
            `, sheet.cssRules.length);
                }
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    changeHeaderBorderBottom();
    removeDoubleSpace();
    sieroty();
});

